import React from 'react';
import { styled } from '@mui/material/styles';
import { ListItem } from '@mui/material';
import { ECategoryGroupDisplayCode, ICategoryGroup } from 'components/menu/model/Menu';

const StyledListItem = styled(ListItem, {
    shouldForwardProp: prop => prop !== 'categoryGroup'
})<{ categoryGroup: ICategoryGroup }>(({ theme, categoryGroup }) => ({
    borderRadius: theme.shape.borderRadius,
    paddingTop: categoryGroup.displayCode === ECategoryGroupDisplayCode.LARGE ? `${200 / 3}%` : `${100 / 3}%`,
    paddingBottom: theme.spacing(0),
    backgroundImage: `url(${categoryGroup.imageUrl})`,
    backgroundSize: 'cover',
    marginTop: theme.spacing(1),
    boxShadow: !!categoryGroup.imageUrl ? 'none' : '0 0 40px 0 #c2c2c2'
}));

interface IMenuCategoryGroupProps {
    onClick: (categoryGroup: ICategoryGroup) => void;
    categoryGroup: ICategoryGroup;
}

export const MenuCategoryGroup: React.FC<React.PropsWithChildren<IMenuCategoryGroupProps>> = props => {
    const { onClick, categoryGroup } = props;

    const handleClick = React.useCallback(() => onClick(categoryGroup), [categoryGroup, onClick]);

    return <StyledListItem categoryGroup={categoryGroup} onClick={handleClick} disableGutters />;
};
